<template>
  <RankStar14 v-if="rank === 4" />
  <RankGold14 v-else-if="rank === 3" />
  <RankSilver14 v-else-if="rank === 2" />
  <RankBronze14 v-else-if="rank === 1" />
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";

// @ts-ignore
import RankStar14 from "@/assets/svg/rank/RankStar@14.svg?component";
// @ts-ignore
import RankGold14 from "@/assets/svg/rank/RankGold@14.svg?component";
// @ts-ignore
import RankSilver14 from "@/assets/svg/rank/RankSilver@14.svg?component";
// @ts-ignore
import RankBronze14 from "@/assets/svg/rank/RankBronze@14.svg?component";

@Component({
  components: {
    RankStar14,
    RankGold14,
    RankSilver14,
    RankBronze14
  }
})
export default class RankIcon14 extends Vue {
  @Prop({
    type: Number,
    required: true
  })
  rank!: number;
}
</script>
